import React from "react";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";

import { connect } from "react-redux";
import { compose } from "redux";
import Button from "pages/_components/Button";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import { shape, bool, func } from "prop-types";
import { getLimitDate } from "util/date";

import * as i18n from "util/i18n";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import { selectors as accountsSelectors } from "reducers/accounts";
import Selector from "pages/_components/fields/formik/Selector";
import { isDesktop } from "react-device-detect";
import { Row } from "react-bootstrap";
import { useGetAccounts } from "hooks/useAccounts";

const FORM_ID = "deposits.historical.filters";

const HistoricalDepositsFilter = (props) => {
    HistoricalDepositsFilter.propTypes = {
        isSubmitting: bool.isRequired,
        accounts: shape([]).isRequired,
        dispatch: func,
        setFieldValue: func,
    };
    HistoricalDepositsFilter.defaultProps = {
        isSubmitting: false,
        setFieldValue: () => {},
    };

    const { isSubmitting, accounts, setFieldValue } = props;

    useGetAccounts();

    const accountOptions = accounts.map((account) => ({
        value: account.productId,
        label: `${account.accountType} ${i18n.get(`currency.label.${account.currency}`)} ${account.accountNumber}`,
    }));

    const depositsTypeOptions = [
        {
            value: "PF-ARS",
            label: i18n.get("deposits.depositType.nonTransferable"),
        },
        {
            value: "PF-USD",
            label: i18n.get("deposits.depositType.nonTransferableUSD"),
        },
    ];

    HistoricalDepositsFilter.propTypes = {
        isSubmitting: bool,
    };

    HistoricalDepositsFilter.defaultProps = {
        isSubmitting: false,
    };
    const hadleClearFilters = () => {
        setFieldValue("dueDateRange", [null, null]);
        setFieldValue("account", null);
        setFieldValue("depositType", null);
    };

    return (
        <Form>
            <Row>
                <Col sm={12} md={6} className="col-no-pad-mobile">
                    <div className="form-group">
                        <Field
                            component={DateRangeField}
                            idForm={FORM_ID}
                            minDate={getLimitDate(-3650)}
                            maxDate={getLimitDate(3650)}
                            name="dueDateRange"
                            dateFormat="dd/MM/yyyy"
                            popperPlacement="bottom"
                            selectsRange
                            showMonthYearDropdown
                            showGlobalPlaceholder
                            scrollableMonthYearDropdown
                        />
                    </div>
                </Col>

                <Col sm={12} md={6} className="col-no-pad-mobile">
                    <div className="form-group form-group--select">
                        <Field
                            idForm={FORM_ID}
                            name="depositType"
                            component={Selector}
                            options={depositsTypeOptions}
                            placeholder={i18n.get("global.select.option.placeholder")}
                        />
                    </div>
                </Col>

                <Col sm={12} md={6} className="col-no-pad-mobile">
                    <div className="form-group form-group--select">
                        <Field
                            idForm={FORM_ID}
                            name="account"
                            component={Selector}
                            options={accountOptions}
                            placeholder={i18n.get("global.select.account.placeholder")}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="col-no-pad-mobile">
                    <Button bsStyle="outline" label="fixed.term.clean.filters" onClick={hadleClearFilters} />
                </Col>
                <Col sm={12} md={6} className={`col-no-pad-mobile ${!isDesktop && "mt-8"}`}>
                    <Button bsStyle="primary" label="product.filters.filter" loading={isSubmitting} type="submit" />
                </Col>
            </Row>
        </Form>
    );
};

const mapStateToProps = (state) => ({
    historicalDeposits: depositsSelectors.getHistoricalDeposits(state),
    accounts: accountsSelectors.getAccounts(state),
    filters: depositsSelectors.getFilters(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: true,
        mapPropsToValues: (state) => {
            const dateF = getLimitDate(-3652).toLocaleDateString("en-GB");
            const dateT = getLimitDate(0).toLocaleDateString("en-GB");
            let dateFArr;
            let dateTArr;
            let DateRange;
            if (state?.filters?.dueDateRange?.length > 0) {
                dateFArr = state?.filters?.dueDateRange[0].toLocaleDateString("en-GB");
                dateTArr = state?.filters?.dueDateRange[1].toLocaleDateString("en-GB");
            }
            if (dateFArr === dateF && dateTArr === dateT) {
                DateRange = [null, null];
            } else {
                DateRange = state?.filters?.dueDateRange;
            }
            return {
                creationDateFrom: state?.filters?.creationDateFrom || null,
                creationDateTo: state?.filters?.creationDateTo || null,
                dueDateRange: DateRange || [null, null],
                dueDateFrom: state?.filters?.dueDateFrom || null,
                dueDateTo: state?.filters?.dueDateTo || null,
                depositType: state?.filters?.depositType || null,
                account: state?.filters?.account || null,
            };
        },
        validationSchema: () =>
            Yup.lazy(() =>
                Yup.object().shape({
                    dueDateRange: Yup.array().of(Yup.date().nullable()),
                    depositType: Yup.string().nullable(),
                    account: Yup.string().nullable(),
                }),
            ),
        handleSubmit: (filters, formikBag) => {
            const { dispatch, closeSidebar, handleSearchHistory } = formikBag.props;
            handleSearchHistory();
            if (filters.dueDateRange[0] != null) {
                dispatch(
                    depositsActions.listHistoricalDeposits(
                        { ...filters, dueDateFrom: filters.dueDateRange[0], dueDateTo: filters.dueDateRange[1] },
                        formikBag,
                        closeSidebar,
                    ),
                );
            } else {
                dispatch(
                    depositsActions.listHistoricalDeposits(
                        {
                            ...filters,
                            dueDateFrom: getLimitDate(-3652),
                            dueDateTo: getLimitDate(0),
                            dueDateRange: [getLimitDate(-3652), getLimitDate(0)],
                        },
                        formikBag,
                        closeSidebar,
                    ),
                );
            }
        },
    }),
)(HistoricalDepositsFilter);
